<template>
  <component :is="level" :class="getClass">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseHeader',

  props: {
    level: { default: 'h2', type: String },
    noBottomMargin: Boolean,
    size: { default: 'h3', type: String }
  },

  computed: {
    getClass () {
      const classes = [this.size]

      if (!this.noBottomMargin) {
        classes.push('mb-5')
      }

      return classes.join(' ')
    }
  }
}
</script>
